import throttle from 'lodash/throttle';

// offset for the cursor from the upper and lower border to start scrolling
const OFFSET = 100;
const MOBILE_OFFSET = 80;
// the scroll speed
const SPEED = 6;

let scrollIncrement = 0;
let isScrolling = false;
let scrolableElement = null;

const goUp = () => {
  scrollIncrement -= SPEED;
  scrolableElement.scrollTop = scrollIncrement;

  if (isScrolling && scrollIncrement >= 0) {
    window.requestAnimationFrame(goUp);
  }
};

const goDown = () => {
  scrollIncrement += SPEED;
  scrolableElement.scrollTop = scrollIncrement;

  if (isScrolling && scrollIncrement <= scrolableElement.scrollHeight) {
    window.requestAnimationFrame(goDown);
  }
};

const onDragOver = event => {
  const clientRect = scrolableElement.getBoundingClientRect();
  const touchOrDragEvent = (event.targetTouches && event.targetTouches[0]) || event;
  const offset = event.targetTouches && event.targetTouches[0] ? MOBILE_OFFSET : OFFSET;
  const isMouseOnTop =
    scrollIncrement >= 0 &&
    touchOrDragEvent.clientY > clientRect.top &&
    touchOrDragEvent.clientY < clientRect.top + offset;
  const isMouseOnBottom =
    scrollIncrement <= scrolableElement.scrollHeight &&
    touchOrDragEvent.clientY > window.innerHeight - offset &&
    touchOrDragEvent.clientY <= window.innerHeight;

  if (!isScrolling && (isMouseOnTop || isMouseOnBottom)) {
    isScrolling = true;
    scrollIncrement = scrolableElement.scrollTop;
    if (isMouseOnTop) {
      window.requestAnimationFrame(goUp);
    } else {
      window.requestAnimationFrame(goDown);
    }
  } else if (!isMouseOnTop && !isMouseOnBottom) {
    isScrolling = false;
  }
};

const throttleOnDragOver = throttle(onDragOver, 300);

export const addEventListenerForScrolableElement = containerId => {
  scrolableElement = document.getElementById(containerId);
  if (!scrolableElement) return null;
  scrolableElement.addEventListener('dragover', throttleOnDragOver);
  scrolableElement.addEventListener('touchmove', throttleOnDragOver);
  return null;
};

export const removeEventListenerForScrolableElement = () => {
  if (!scrolableElement) return null;
  scrolableElement.removeEventListener('dragover', throttleOnDragOver);
  scrolableElement.removeEventListener('touchmove', throttleOnDragOver);
  isScrolling = false;
  return null;
};
